import { Link } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { ContentManager } from "../components/website/ContentManager";
import { GalleryManager } from "../components/website/GalleryManager";
import { AboutContactManager } from "../components/website/AboutContactManager";
import { ArrowSquareOut } from "@phosphor-icons/react";

const TABS = [
  { v: "news", l: "News (Media Point)" },
  { v: "gallery", l: "Photo Gallery" },
  { v: "careers", l: "Careers" },
  { v: "achievements", l: "Achievements" },
  { v: "about", l: "About & Contact" },
];

export default function WebsiteContent() {
  return (
    <div className="space-y-6" data-testid="website-content-page">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-3xl font-black">Website Content</h1>
          <p className="text-zinc-500 mt-1">Changes go live on the public home page immediately.</p>
        </div>
        <Link to="/" target="_blank" data-testid="view-website-link" className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-700 hover:text-indigo-900 transition-colors">
          View website <ArrowSquareOut size={16} />
        </Link>
      </div>
      <Tabs defaultValue="news">
        <TabsList className="flex-wrap h-auto">
          {TABS.map((t) => <TabsTrigger key={t.v} value={t.v} data-testid={`website-tab-${t.v}`}>{t.l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="news" className="mt-6"><ContentManager kind="news" /></TabsContent>
        <TabsContent value="gallery" className="mt-6"><GalleryManager /></TabsContent>
        <TabsContent value="careers" className="mt-6"><ContentManager kind="careers" /></TabsContent>
        <TabsContent value="achievements" className="mt-6"><ContentManager kind="achievements" /></TabsContent>
        <TabsContent value="about" className="mt-6"><AboutContactManager /></TabsContent>
      </Tabs>
    </div>
  );
}
